.ux-iws-software-updates-tooltip {
    position: relative;

    &__list {
        display: flex;
        align-items: center;

        ux-icon {
            width: 15px;
        }

        ux-icon[name="cross"] {
            color: $color-gray-40;
        }
    }
}
